import { API } from 'aws-amplify'

import { SoundType } from '../types'

export const getRandomSounds = async (): Promise<{positiveFeedback: SoundType, negativeFeedback: SoundType}> => {
    const sounds = await API.get('openapi', '/sounds/random', {})
    return sounds
}
